import { api } from './api';

// Define a service using a base URL and expected endpoints for AI providers
export const aiProviderApi = api.injectEndpoints({
  reducerPath: 'aiProviderApi',
  tagTypes: ['AiProviders', 'AiModels'],
  endpoints: (builder) => ({
    getAiProviders: builder.query({
      query: () => ({
        url: `/api/administration/providers`,
        method: 'GET'
      }),
      providesTags: ['AiProviders']
    }),
    getAiProviderById: builder.query({
      query: (id) => ({
        url: `/api/administration/providers/${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, id) => [{ type: 'AiProviders', id }]
    }),
    getAiModelsByProviderId: builder.query({
      query: (providerId) => ({
        url: `/api/administration/providers/${providerId}/models`,
        method: 'GET'
      }),
      providesTags: (result, error, providerId) => [{ type: 'AiModels', providerId }, 'AiModels']
    }),
    createAiProvider: builder.mutation({
      query: (aiProviderRequest) => ({
        url: `/api/administration/providers`,
        method: 'POST',
        body: aiProviderRequest
      }),
      invalidatesTags: ['AiProviders']
    }),
    updateAiProvider: builder.mutation({
      query: ({ id, aiProviderRequest }) => ({
        url: `/api/administration/providers/${id}`,
        method: 'PATCH',
        body: aiProviderRequest
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'AiProviders', id }, 'AiProviders']
    }),
    deleteAiProvider: builder.mutation({
      query: (id) => ({
        url: `/api/administration/providers/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'AiProviders', id },
        'AiProviders',
        'AiModels'
      ]
    }),
    bulkDeleteAiProviders: builder.mutation({
      query: (ids) => ({
        url: `/api/administration/providers`,
        method: 'DELETE',
        body: ids
      }),
      invalidatesTags: ['AiProviders', 'AiModels']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAiProvidersQuery,
  useGetAiProviderByIdQuery,
  useGetAiModelsByProviderIdQuery,
  useCreateAiProviderMutation,
  useUpdateAiProviderMutation,
  useDeleteAiProviderMutation,
  useBulkDeleteAiProvidersMutation
} = aiProviderApi;
